import React from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch } from 'reduxTyped'
import { BtnV2, Icon, l } from '@manychat/manyui'

import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { typedRouting } from 'utils/router'

import cm from './styles.module.css'

export const InvalidKnowledge = () => {
  const dispatch = useAppDispatch()

  return (
    <section className="h-full">
      <SidebarHeader title={l.translate('Always-On Answers')} />
      <div className={cm.wrapper}>
        <div className={cm.content}>
          <Icon.Attention className="text-danger" size={32} />

          <h3 className="m-t-sm text-subheading">
            {l.translate('Always-On Answers can’t be enabled')}
          </h3>

          <p className="m-t-xs">
            {l.translate(
              'There’s an issue with your Training info. Review it to enable Always-On Answers.',
            )}
          </p>

          <BtnV2
            as={Link}
            to={typedRouting.linkBuilder.aiTraining()}
            onClick={() => dispatch(AiAutomationLayoutActions.sidebarClosed())}
            variant="primary"
            fullWidth
            className="m-t-md"
          >
            {l.translate('Manage Training')}
          </BtnV2>
        </div>
      </div>
    </section>
  )
}
